import React, { useState, useEffect } from "react";
import { Chip, Divider, Stack, Typography } from "@mui/material";
import { OutlinedButton } from "../../../Utils/ButtonHelper";
import AllShopCards from "./AllShopCards";
// import {shops} from "./AllShopsData.json";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { handleSpringDataRequest } from "../../../api/index";
import * as BiIcons from "react-icons/bi";
import { ShopCardLoaders } from "../Shop/Utils/CardLoaders";
import { useTranslation } from "react-i18next";

import PaymentModal from "../../AccessControl/PaymentModal";

function AllShops({ data }) {
  const { t } = useTranslation();

  // Get the basic information from the redux
  const hotelId = data.hotelId;

  // Field we will get through API call for all shops
  /*
    1. Id
    2. Hotel Id
    2. Shop Name
    3. Shop Description
    4. Shop Tax
    5. Self Service
    5. Image (This comes after toggling the display when clicking on the Next button)
  */
  //Once we come to this page we will get all shops data by calling API through useEffect
  const [shops, setShops] = useState(null);

  // Loader untill API loads all data into shops
  const [loadingShops, setLoadingShops] = useState(false);

  const getShopData = () => {
    setLoadingShops(true);
    handleSpringDataRequest(
      `core/api/v1/shop/category/get-all?email=${localStorage.getItem("email")}`
    )
      // .then((res) => console.log(res))
      .then((res) => setShops(res))
      .then((res) => setLoadingShops(false));
  };

  useEffect(() => {
    getShopData();
  }, []);

  const [utgst, setUtgst] = useState({});
  const getUtgstStatus = () => {
    handleSpringDataRequest("core/api/v1/utgst-config/get")
      .then((data) => {
        if (data) {
          setUtgst(data);
          if (data?.status === "ENABLED") {
            localStorage.setItem("utgstStatus", "ENABLED");
          } else {
            localStorage.setItem("utgstStatus", "DISABLED");
          }
        } else {
          localStorage.setItem("utgstStatus", "DISABLED");
        }
      })
      .catch((err) => {
        localStorage.setItem("utgstStatus", "DISABLED");
      });
  };
  useEffect(() => {
    getUtgstStatus();
  }, []);

  // Display label
  const handleRenderLabel = () => {
    const length = shops?.filter(
      (shop) => shop?.shop_status.toLowerCase() === "active"
    ).length;
    if (length === 0) {
      return `${t("You have no outlets. Please create one.")}`;
    } else if (length === 1) {
      return `${t("You are viewing a single outlet.")}`;
    } else if (length > 1) {
      return (
        `${t("You are viewing")}` + ` ${length} ` + `${t("active outlets.")}`
      );
    }
  };

  // Render no data tag
  const renderNoDataTag = () => {
    return (
      <Stack
        className="mt-10 position-relative w-100 align-items-center"
        spacing={2}
        style={{ marginTop: 10 }}
      >
        <Typography style={{ color: "grey" }}>
          {t("No data found !")}
        </Typography>
      </Stack>
    );
  };

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const closePaymentModal = () => {
    setShowPaymentModal(false);
  };
  const [paymentAmount, setpaymentAmount] = useState(0);
  const [daysDiff, setdaysDiff] = useState(0);

  const [finalDate, setfinalDate] = useState(new Date());

  useEffect(() => {
    if (
      localStorage.getItem("mainGroupId") &&
      localStorage.getItem("mainGroupId") !== undefined &&
      localStorage.getItem("mainGroupId") !== null
    ) {
      handleSpringDataRequest(
        `web-api/get-payment-dues-amount?groupId=${localStorage.getItem(
          "mainGroupId"
        )}`
      ).then((res) => {
        if (
          res.pendingAmount < 0 &&
          Number(res.daysDiff) >= 15 &&
          Number(res.daysDiff) <= 30 &&
          res.showBanner === "YES"
        ) {
          setpaymentAmount(res.pendingAmount);
          setShowPaymentModal(true);
          setdaysDiff(Number(res.daysDiff));
          setfinalDate(res.date);
        }
      });
    }
  }, [localStorage.getItem("mainGroupId")]);

  return (
    <div className="allShopsWrappers">
      <Stack spacing={3}>
        <div className="d-flex justify-content-between ml-4 mr-4">
          {shops && (
            <div
              style={{
                background:
                  "-webkit-linear-gradient(-150deg, #1ab394, #1a91ae)",
                borderRadius: "5px",
                color: "white",
                fontWeight: "bold",
                padding: "9px 12px 6px 12px",
              }}
              // label={handleRenderLabel()}
            >
              {handleRenderLabel()}
            </div>
          )}
          {data?.accessControl?.user_feature_map?.POSAddUpdateShop &&
            JSON.parse(data?.accessControl?.user_feature_map?.POSAddUpdateShop)
              ?.read === "YES" && (
              <Link
                to={{
                  pathname: "/allOutlets/addOutlet",
                  search: `?hotelId=${hotelId}`,
                }}
                style={{ textDecoration: "none" }}
              >
                <OutlinedButton text={t("Add Shop")} />
              </Link>
            )}
        </div>
        <Divider />
        {shops ? (
          shops.length > 0 ? (
            shops?.map(
              (shop, index) =>
                shop?.shop_status.toLowerCase() === "active" && (
                  <AllShopCards
                    hotelId={hotelId}
                    id={shop.id}
                    shopName={shop.shop_name}
                    description={shop.shop_desc}
                    selfService={shop.enable_for_self_service}
                    imageUrl={shop.image_url}
                    fnb={
                      shop?.shop_type?.toLowerCase() === "other" ? false : true
                    }
                    data={data}
                  />
                )
            )
          ) : (
            renderNoDataTag()
          )
        ) : (
          <ShopCardLoaders />
        )}

        <PaymentModal
          showPaymentModal={showPaymentModal}
          paymentAmount={paymentAmount}
          closePaymentModal={closePaymentModal}
          days={daysDiff}
          finalDate={finalDate}
        />
      </Stack>
    </div>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(AllShops);
